// LinkedIn-style filled monochrome tab icons.
// Each icon is a single <svg> at 24×24 with fill="currentColor" so the parent
// button can colour it via CSS color: black (active) or grey (inactive).

const svgProps = (size) => ({
  width: size,
  height: size,
  viewBox: "0 0 24 24",
  fill: "currentColor",
  "aria-hidden": true,
  focusable: false,
});

export const HomeIcon = ({ size = 24 }) => (
  <svg {...svgProps(size)}>
    <path d="M12 2.6L2.5 11h2.7v10h4.1v-6.2h5.4V21h4.1V11h2.7z" />
  </svg>
);

export const TxnIcon = ({ size = 24 }) => (
  <svg {...svgProps(size)}>
    <path d="M3 6h18v3H3zM3 11h18v7a1 1 0 01-1 1H4a1 1 0 01-1-1zm3 4h4v2H6z" />
  </svg>
);

export const InvestIcon = ({ size = 24 }) => (
  <svg {...svgProps(size)}>
    <path d="M3 20h18v1H3zM7 18H4v-6h3zM12 18H9V8h3zM17 18h-3v-9h3zM21 18h-3v-4h3z" />
  </svg>
);

export const FamilyIcon = ({ size = 24 }) => (
  <svg {...svgProps(size)}>
    <path d="M8 11a3.5 3.5 0 100-7 3.5 3.5 0 000 7zm8 0a3 3 0 100-6 3 3 0 000 6zM2 19c0-3 4-4.5 6-4.5s6 1.5 6 4.5v2H2zm12 0v2h8v-2c0-2.5-3-4-5-4l-1 .2c.7 1 1 2.2 1 3.8z" />
  </svg>
);

export const AIIcon = ({ size = 24 }) => (
  <svg {...svgProps(size)}>
    <path d="M12 2l1.5 4.5L18 8l-4.5 1.5L12 14l-1.5-4.5L6 8l4.5-1.5zM18.5 14l.8 2.2 2.2.8-2.2.8-.8 2.2-.8-2.2-2.2-.8 2.2-.8zM5.5 14l.8 2.2 2.2.8-2.2.8-.8 2.2-.8-2.2-2.2-.8 2.2-.8z" />
  </svg>
);

export const RoadmapIcon = ({ size = 24 }) => (
  <svg {...svgProps(size)}>
    <path d="M5 3v18h2v-7l7 1.5 1-5.5 4 .5V4l-5-.5-1 5.5-7-1.5z" />
  </svg>
);

export const TabIcon = ({ name, size = 24 }) => {
  switch (name) {
    case "home":    return <HomeIcon size={size} />;
    case "txn":     return <TxnIcon size={size} />;
    case "invest":  return <InvestIcon size={size} />;
    case "family":  return <FamilyIcon size={size} />;
    case "ai":      return <AIIcon size={size} />;
    case "roadmap": return <RoadmapIcon size={size} />;
    default:        return null;
  }
};
